import React from 'react'
import productListInformationFragment from '@data/fragments/products/productListInformation.main'
import HasWebpSupport from '@helpers/misc/hasWebpSupport'
import useOptimisticCheckout from '@page-components/CheckoutV3/hooks/useOptimisticCheckout'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import SelectProduct from '@page-components/Order/Products/ProductsContent/SelectProduct'
import {useRefetchQueries} from 'apollo-hooks'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import {
  CheckoutV3UpsellingSelectProduct,
  CheckoutV3UpsellingSelectProductVariables
} from './__generated__/CheckoutV3UpsellingSelectProduct'

export default function AddToCart({productId, onClose}: {productId: string; onClose: () => void}) {
  const {preferences} = usePreferences()
  const refetch = useRefetchQueries()
  const {optimisticStart, optimisticEnd} = useOptimisticCheckout()

  const {data} = useQuery<
    CheckoutV3UpsellingSelectProduct,
    CheckoutV3UpsellingSelectProductVariables
  >({
    query: gql`
      query CheckoutV3UpsellingSelectProduct(
        $productId: ID!
        $menuId: ID!
        $format: String
        $deliverAt: Date
        $storeId: ID
      ) {
        product(productId: $productId) {
          ...productListInformation
        }
      }
      ${productListInformationFragment}
    `,
    variables: {
      productId,
      menuId: preferences.menuId,
      format: HasWebpSupport() ? 'webp' : 'jpeg',
      storeId: preferences.storeId,
      deliverAt: preferences.deliverAt
    },
    omit: !productId,
    fetchPolicy: 'cache-first'
  })

  const product = data?.product

  if (!product) return null

  return (
    <SelectProduct
      allowEdit={false}
      product={product}
      open={true}
      onAdd={async () => {
        optimisticStart()
        await refetch(['getCheckoutV3'])
        optimisticEnd()
      }}
      close={onClose}
    />
  )
}
